import { defineLocalStore } from '@/utils/localStore'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { Assignment, InternalStaffUnit } from '@/utils/types/internalStaffUnit'
import { openDialog } from '@/dialog'
import { handleAsync, setSnackbar, confirm } from 'best-modules/plugins'
import { internalStaffUnitSingle } from '@/requests/internalStaffUnit'
import { sendRequest } from 'best-modules/vue-utils'

export const {
  useLocalStore: useInternalStaffUnit,
  initLocalStore: initInternalStaffUnit,
} = defineLocalStore('internalStaffUnit', () => {
  const route = useRoute()
  const internalStaffUnitId = computed<number>(() => {
    return Number(route.params.id)
  })
  const internalStaffUnit = ref<InternalStaffUnit>({} as InternalStaffUnit)

  const getInternalStaffUnit = () => {
    return handleAsync('internalStaffUnitSingle', () => {
      return internalStaffUnitSingle(internalStaffUnitId.value).then(res => {
        internalStaffUnit.value = res
      })
    })
  }

  const hasActiveAssignment = computed(() => {
    return !!internalStaffUnit.value?.activeAssignment
  })

  const historyAssignments = computed(() => {
    const today = new Date().toISOString().slice(0, 10)
    return (internalStaffUnit.value?.assignments || []).filter(
      a => a.dateTo && a.dateTo <= today
    )
  })

  const futureAssignments = computed(() => {
    const today = new Date().toISOString().slice(0, 10)
    return (internalStaffUnit.value?.assignments || []).filter(
      a => a.dateFrom > today
    )
  })

  const dismissAssignment = () => {
    if (!internalStaffUnit.value?.activeAssignment?.id) return
    return confirm({
      text: `Ви дійсно бажаєте звільнити ${internalStaffUnit.value.activeAssignment.employee?.name} ${internalStaffUnit.value.activeAssignment.employee?.surname} з посади?`,
    }).then(() => {
      return handleAsync('dismissAssignment', () => {
        return sendRequest({
          name: 'dismissAssignment',
          method: 'patch',
          url: `/json/orgStructure/assignment/${internalStaffUnit.value.activeAssignment!.id}/dismiss`,
        }).then(() => {
          setSnackbar({ text: 'Співробітника звільнено' })
          return getInternalStaffUnit()
        })
      })
    })
  }

  const editAssignment = (assignment: Assignment) => {
    openDialog({
      name: 'StaffUnitAssignment',
      action: 'update',
      params: {
        title: 'Редагувати співробітника',
        subtitle: 'Оберіть співробітника та вкажіть параметри',
        cb: () => getInternalStaffUnit(),
      },
      dialogData: {
        itemData: assignment,
        staffUnit: internalStaffUnit.value,
        otherAssignments: (internalStaffUnit.value?.assignments || []).filter(
          a => a.id !== assignment.id
        ),
      },
    })
  }

  const addAssignment = () => {
    openDialog({
      name: 'StaffUnitAssignment',
      action: 'create',
      params: {
        title: 'Призначення',
        subtitle: 'Оберіть співробітника та вкажіть параметри',
        cb: () => getInternalStaffUnit(),
      },
      dialogData: {
        staffUnit: internalStaffUnit.value,
        otherAssignments: internalStaffUnit.value?.assignments || [],
      },
    })
  }

  getInternalStaffUnit()

  return {
    internalStaffUnitId,
    internalStaffUnit,
    hasActiveAssignment,
    historyAssignments,
    futureAssignments,
    getInternalStaffUnit,
    addAssignment,
    editAssignment,
    dismissAssignment,
  }
})
